import CFS from '@/services/config-file.service.js'
import * as types from './mutation-types.js'
import HF from './help-functions.js'
import Vue from 'vue'
import iconsMixin from '@/mixins/icons.js'
const icons = iconsMixin.data().icons
const helpFunctions = new HF()
const configFileService = new CFS()

/* global $  */
export const mutations = {
  [types.PUSH_FILE_CONNECTIONS_TO_LIST_OF_CONNECTIONS](
    state,
    connectionsFromFile
  ) {
    console.log('listOfConnections updaten')
    state.listOfConnections.splice(
      0,
      state.listOfConnections.length
    )
    for (var x = 0; x < connectionsFromFile.length; x++) {
      Vue.set(state.listOfConnections, x, connectionsFromFile[x])
    }
    console.log(state.listOfConnections)
    state.listOfConnections = connectionsFromFile
  },
  [types.SET_LOGIN_REDIRECTED] (state, boolean) {

    state.flags.isLoginRedirected = boolean
  },
  [types.SET_CURRENT_CONNECTION_API](state, api) {
    state.api = api
  },
  [types.ADD_CONNECTION_TO_LIST_OF_CONNECTIONS](state, dit) {
    let newConnection = dit.connectionObject
    state.listOfConnections.push(
      helpFunctions.createConnectionObject(newConnection, dit.connectionTypes)
    )
    configFileService.writeFile(state.listOfConnections, dit)
  },
  [types.EDIT_CONNECTION_IN_LIST_OF_CONNECTIONS](state, dit) {
    let editConnection = dit.connectionObject
    let itemIdx = state.listOfConnections.findIndex(
      conn => conn.ID === editConnection.ID
    )
    editConnection = helpFunctions.editConnectionObject(editConnection, dit.connectionTypes)
    state.listOfConnections[itemIdx] = editConnection
    configFileService.writeFile(state.listOfConnections)
  },
  [types.DELETE_CONNECTION_FROM_LIST_OF_CONNECTIONS](state, dit) {
    let delConnectionID = dit.connectionObject.ID
    state.listOfConnections = state.listOfConnections.filter(
      conn => conn.ID !== delConnectionID
    )
    configFileService.writeFile(state.listOfConnections, dit)
  },
  [types.LOCK_SCREEN](state, params) {
    let timing = 5000
    var doNotAutoEnable = null
    var customTimingScreenDisabled = null
    if (!_.isEmpty(params)) {
      doNotAutoEnable = params.doNotAutoEnable
      customTimingScreenDisabled = params.customTimingScreenDisabled
    }
    if (doNotAutoEnable) {
      state.flags.screenDisabled = true
      state.flags.screenLocked = true
    } else if (customTimingScreenDisabled > 0) {
      timing = customTimingScreenDisabled
      state.flags.screenDisabled = true
    } else {
      state.flags.screenLocked = true
    }
    if (!doNotAutoEnable) {
      setTimeout(function () {
        if (state.flags.screenLocked) {
          state.flags.screenLocked = false
        }
        if (state.flags.screenDisabled) {
          state.flags.screenDisabled = false
        }
      }, timing)
    }
  },
  [types.SET_LOGGED_IN_USER_INFORMATION](state, connection) {
    state.userInfo.loggedInUserInformation = connection
  },
  [types.SET_SCREEN_RIGHTS](state,isScreen) {

    state.userInfo.screensRightsInformation.MijnGegevens = isScreen[0]
    state.userInfo.screensRightsInformation.personaliaBewerken = isScreen[1]
    state.userInfo.screensRightsInformation.myprofile = isScreen[2]
    state.userInfo.screensRightsInformation.Agenda = isScreen[3]
    state.userInfo.screensRightsInformation.Aanwezigheden = isScreen[4]
	state.userInfo.screensRightsInformation.Opleiding = isScreen[5]
    state.userInfo.screensRightsInformation.Betalingen = isScreen[6]

    
  },
  [types.SET_LOGGED_IN_CONNECTION_OBJECT](state, connectionObject) {
    state.userInfo.loggedInConnectionObject = connectionObject
  },
  [types.LOGGED_OUT_ONCE](state) {
    state.userInfo.loggedOutOnce = true
  },
  [types.UNLOCK_SCREEN](state) {
    state.flags.screenLocked = false
    state.flags.screenDisabled = false
  },

  [types.SHOW_MESSAGE](state, params) {
    $('#TOAST-MESSAGE-BOX').stop()
    $('#TOAST-MESSAGE-BOX').css('display', 'none')
    if (typeof params === 'string') {
      state.showedMessage = params
      $('#TOAST-MESSAGE-BOX').text(params)
      $('#TOAST-MESSAGE-BOX')
        .fadeIn(400)
        .delay(1000)
        .fadeOut(400)
    } else {
      state.showedMessage = params[0]
      $('#TOAST-MESSAGE-BOX').text(params[0])
      if (params[1] === 'error') {
        if (params[2] > 0) {
          $('#TOAST-MESSAGE-BOX')
            .fadeIn(400)
            .delay(params[2])
            .fadeOut(400)
        } else {
          $('#TOAST-MESSAGE-BOX')
            .fadeIn(400)
            .delay(2000)
            .fadeOut(400)
        }
      } else if (params[1] === 'long') {
        $('#TOAST-MESSAGE-BOX')
          .fadeIn(400)
          .delay(4000)
          .fadeOut(400)
      } else {
        $('#TOAST-MESSAGE-BOX')
          .fadeIn(400)
          .delay(1000)
          .fadeOut(400)
      }
    }
  },
  [types.SET_MENU_ITEMS](state, mainMenuItems) {
    state.mainMenuItems = mainMenuItems
  },
  
  [types.TOGGLE_MENU](state) {
    state.flags.showMenu = !state.flags.showMenu
    $('#main-menu-body').toggle('fast')
  },
  [types.SET_MENUBAR_ITEMS](state, items) {
    // changePartially flag used!
    if (typeof items.left === 'string') {
      if (items.left === 'menu') {
        state.menubarItems.left = [{
          ICON: icons.MENU,
          FUNCTIE: 'menuTogglen',
          TOOLTIP: 'Menu openen'
        }]
      } else if (items.left === 'back') {
        state.menubarItems.left = [{
          ICON: icons.ARROW_LEFT,
          FUNCTIE: 'goBack',
          TOOLTIP: 'Terug'
        }]
      }
    } else if (typeof items.left !== 'undefined') {
      // assumed that it is then an array
      state.menubarItems.left = items.left
    }
    if (items.changePartially) {
      state.menubarItems.title = typeof items.title === 'undefined' ? state.menubarItems.title : items.title
      state.menubarItems.right = typeof items.right === 'undefined' ? state.menubarItems.right : items.right
      state.menubarItems.rightAsTextButtons = typeof items.rightAsTextButtons === 'undefined' ? state.menubarItems.rightAsTextButtons : items.rightAsTextButtons
      state.menubarItems.rightSideMenuItems = typeof items.rightSideMenuItems === 'undefined' ? state.menubarItems.rightSideMenuItems : items.rightSideMenuItems
    } else {
      state.menubarItems.title = typeof items.title === 'undefined' ? '' : items.title
      state.menubarItems.right = typeof items.right === 'undefined' ? [] : items.right
      state.menubarItems.rightAsTextButtons = typeof items.rightAsTextButtons === 'undefined' ? [] : items.rightAsTextButtons
      state.menubarItems.rightSideMenuItems = typeof items.rightSideMenuItems === 'undefined' ? [] : items.rightSideMenuItems
    }
  },
  [types.SET_MENUBAR_RIGHT_SIDE_MENU_ITEMS](state, rightSideMenuItems) {
    state.menubarItems.rightSideMenuItems = rightSideMenuItems
  },
  [types.SET_MENUBAR_RIGHT_SIDE_MENU_VISIBLE](state, visible) {
    state.menubarItems.isRightSideMenuOpen = visible
  },
  [types.SET_TITLE_OF_MENUBAR](state, title) {
    state.menubarItems.title = title
  },
  [types.IS_HEVERLEE_USER](state, serverLocation) {
    console.log('----------------------')
    console.log(serverLocation)
    state.userInfo.isHeverleeUser = serverLocation.indexOf('schoolware.hhscholen.be') !== -1 ||
      serverLocation.indexOf('hhh.schoolware.be') !== -1
  },
  [types.SET_EXTERNAL_LINK_FOR_EVALUATION](state) {
    if (state.userInfo.isLeerkracht) {
      state.externalLinkForEvaluation = 'https://rapport.hhscholen.be/puntenboek/default.aspx'
    } else if (state.userInfo.isLeerling) {
      state.externalLinkForEvaluation = 'https://schoolware.hhscholen.be/webleerling/bin/server.fcgi/TokenRedirect/LLRapport?LL_ID=' + state.userInfo
        .leerlingID
    } else if (state.userInfo.isOuder) {
      state.externalLinkForEvaluation = 'https://schoolware.hhscholen.be/webouders/bin/server.fcgi/TokenRedirect/LLRapport?LL_ID='
    }
  },
  [types.SET_LEERLING_ID](state, llID) {
    state.userInfo.leerlingID = llID
  },
  [types.SET_ACTIVE_MODULE](state, moduleName) {
    state.activeModule = moduleName
  },
  [types.MODULE_CHANGING_USING_MAIN_MENU](state, booleanValue) {
    state.flags.moduleChangingUsingMainMenu = booleanValue
  },
 
 
  [types.SET_TEXT_BUTTONS_ON_MENUBAR](state, rightAsTextButtons) {
    state.menubarItems.rightAsTextButtons = rightAsTextButtons
  },
  [types.SET_VERSIENUMMER](state, versienummer) {
    state.versienummer = versienummer
  },
  [types.SET_PROJECT_NAAM](state, projectNaam) {
    state.projectNaam = projectNaam
  },
  [types.LOGGED_IN](state) {
    state.flags.loggedIn = true
  },
  [types.SET_USERS_TYPE](state, usersTypePropAsString) {
    state.userInfo[usersTypePropAsString] = true
  },
  [types.SET_STATE_TO_INITIAL_VALUES](state) {
    // let init = JSON.parse(JSON.stringify(state.initialValues))
    // for (var property in init) {
    //   if (
    //     init.hasOwnProperty(property) &&
    //     property !== 'listOfConnections' &&
    //     property !== 'title' &&
    //     property !== 'versienummer' &&
    //     property !== 'projectNaam'
    //   ) {
    //     state[property] = init[property]
    //   }
    // }
    // state.userInfo.loggedInConnectionObject = null
    let init = JSON.parse(JSON.stringify(state.initialValues))
    for (var property in init) {
      if (init.hasOwnProperty(property)) {
        state[property] = init[property]
      }
    }
   
  },
  [types.INITIALIZE_DROPDOWN_PAGE](state, payload) {
    // if dropdown was not defined before OR if it was given that data should be kept after made a selection
    if (
      typeof state.allDropdownMenus[payload.dropdownID] === 'undefined' ||
      !state.allDropdownMenus[payload.dropdownID].keepDataAfterSelection
    ) {
      let newDropdown = {}
      newDropdown.propertyToBeShown = payload.propertyToBeShown
      newDropdown.listOfItems = payload.listOfItems
      newDropdown.title =
        typeof payload.title !== 'undefined' ? payload.title : 'Maak een keuze'
      newDropdown.keepDataAfterSelection = typeof payload.keepDataAfterSelection !== 'undefined' ?
        payload.keepDataAfterSelection :
        true
      newDropdown.isMultiSelect = typeof payload.isMultiSelect !== 'undefined' ?
        payload.isMultiSelect :
        false
      newDropdown.showFilterBar = typeof payload.showFilterBar !== 'undefined' ?
        payload.showFilterBar :
        false
      newDropdown.atLeastOneSelectedItemRequired = typeof payload.atLeastOneSelectedItemRequired !== 'undefined' ?
        payload.atLeastOneSelectedItemRequired :
        false
      newDropdown.selectAllButtonName = payload.selectAllButtonName === 'undefined' ?
        'Selecteer alles' :
        payload.selectAllButtonName
      newDropdown.selectAllButtonVisible = typeof payload.selectAllButtonVisible !== 'undefined' ?
        payload.selectAllButtonVisible :
        false
      newDropdown.listOfItems.map(function (item, idx) {
        item._ID_DROPDOWN_PAGE = idx
        item._SELECTED_DROPDOWN_PAGE = typeof item._SELECTED_DROPDOWN_PAGE === 'undefined' ?
          false :
          item._SELECTED_DROPDOWN_PAGE
      })
      if (newDropdown.selectAllButtonVisible) {
        newDropdown.listOfItems.unshift({
          _ID_DROPDOWN_PAGE: -1,
          _SELECTED_DROPDOWN_PAGE: false,
          [newDropdown.propertyToBeShown]: newDropdown.selectAllButtonName
        })
      }
      state.allDropdownMenus[payload.dropdownID] = newDropdown
    }
    state.currentDropdownMenu = payload.dropdownID
  },
  [types.UPDATE_LIST_OF_ITEMS_OF_DROPDOWN](state, newListOfItems) {
    state.allDropdownMenus[state.currentDropdownMenu].listOfItems = {}
    state.allDropdownMenus[state.currentDropdownMenu].listOfItems = newListOfItems
  },
  [types.UNLOCK_LOGIN_PROCEDURE](state) {
    state.flags.loginProcedureLocked = false
  },
  [types.LOCK_LOGIN_PROCEDURE](state) {
    state.flags.loginProcedureLocked = true
  },
  [types.CLOSE_DIALOG](state, flag) {
    state.closeDialog = flag
  },
  [types.LAST_ACTIVE_DIALOG](state, dialog) {
    state.lastActiveDialog = dialog
  },
}
